import React from 'react';
import Icon from '../../../components/AppIcon';

const AdminStatistics = ({ language }) => {
  const statistics = [
    {
      id: 'total-revenue',
      labelEn: 'Total Revenue (This Month)',
      labelFr: 'Revenu Total (Ce Mois)',
      labelAr: 'إجمالي الإيرادات (هذا الشهر)',
      value: 245000,
      currency: 'MAD',
      icon: 'TrendingUp',
      color: 'bg-success/10 text-success'
    },
    {
      id: 'pending-payments',
      labelEn: 'Pending Payments',
      labelFr: 'Paiements en Attente',
      labelAr: 'المدفوعات المعلقة',
      value: 87500,
      currency: 'MAD',
      icon: 'Clock',
      color: 'bg-warning/10 text-warning'
    },
    {
      id: 'active-users',
      labelEn: 'Active Users',
      labelFr: 'Utilisateurs Actifs',
      labelAr: 'المستخدمون النشطون',
      value: 6,
      icon: 'Users',
      color: 'bg-primary/10 text-primary'
    },
    {
      id: 'case-completion',
      labelEn: 'Case Completion Rate',
      labelFr: 'Taux de Clôture',
      labelAr: 'معدل إنجاز القضايا',
      value: 78,
      suffix: '%',
      icon: 'CheckCircle',
      color: 'bg-accent/10 text-accent'
    }
  ];

  const getLabel = (stat) => {
    if (language === 'fr') return stat?.labelFr;
    if (language === 'ar') return stat?.labelAr;
    return stat?.labelEn;
  };

  const formatValue = (stat) => {
    if (stat?.currency) {
      if (language === 'ar') {
        return `${new Intl.NumberFormat('ar-MA')?.format(stat?.value)} ${stat?.currency}`;
      }
      return `${new Intl.NumberFormat('fr-MA')?.format(stat?.value)} ${stat?.currency}`;
    }
    if (stat?.suffix) {
      if (language === 'ar') {
        return `${new Intl.NumberFormat('ar-MA')?.format(stat?.value)}${stat?.suffix}`;
      }
      return `${new Intl.NumberFormat('fr-MA')?.format(stat?.value)}${stat?.suffix}`;
    }
    if (language === 'ar') {
      return new Intl.NumberFormat('ar-MA')?.format(stat?.value);
    }
    return new Intl.NumberFormat('fr-MA')?.format(stat?.value);
  };

  const titleLabel = {
    en: 'Firm Statistics',
    fr: 'Statistiques du Cabinet',
    ar: 'إحصائيات المكتب'
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 shadow-elevation-sm">
      <h2 className="text-lg md:text-xl font-semibold text-foreground mb-4">
        {titleLabel?.[language]}
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {statistics?.map((stat) => (
          <div
            key={stat?.id}
            className="flex items-center gap-4 p-4 rounded-lg bg-muted/50"
          >
            <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${stat?.color}`}>
              <Icon name={stat?.icon} size={24} />
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs text-muted-foreground mb-1">{getLabel(stat)}</p>
              <p className="text-xl font-semibold text-foreground">
                {formatValue(stat)}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminStatistics;